var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_14416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 6H10.6667",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 8.66797H9.33334",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.66797C12.5304 2.66797 13.0391 2.87868 13.4142 3.25376C13.7893 3.62883 14 4.13754 14 4.66797V10.0013C14 10.5317 13.7893 11.0404 13.4142 11.4155C13.0391 11.7906 12.5304 12.0013 12 12.0013H8.66667L5.33333 14.0013V12.0013H4C3.46957 12.0013 2.96086 11.7906 2.58579 11.4155C2.21071 11.0404 2 10.5317 2 10.0013V4.66797C2 4.13754 2.21071 3.62883 2.58579 3.25376C2.96086 2.87868 3.46957 2.66797 4 2.66797H12Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_14416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon08);
export default __webpack_public_path__ + "static/media/dashboard-icon-08.8ebbb00f29f10d27c547554d541542c2.svg";
export { ForwardRef as ReactComponent };